import { connect } from 'react-redux';
import { onRemoveAllSavedFilters } from '../../../store/saved_filters/onRemoveAllSavedFilters';
import { removeSavedFilter } from '../../../store/saved_filters/removeSavedFilter';
import { IGetVillageListResponseSchema } from '../../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';
import { IRailwayDirection } from '../../../types/geo';
import { onChangeRoadDistance } from '../../../store/roads/actions';
import { ISavedFilters } from '../../../store/saved_filters';
import { changeSavedFilter, fitInOneLine, ISavedFilter } from '../../../store/saved_filters/actions';
import { onChangeStationDistance } from '../../../store/stations/actions';
import { SavedFilters } from './index';
import { getStationById } from '../../../utils/stations';
import { pick } from '../../../utils/pick';

export interface ISavedFiltersStoreProps {
  roadData: IGetVillageListResponseSchema['roadData'];
  stationData: IGetVillageListResponseSchema['stationData'];
  savedFilters: ISavedFilters;
  stationDirectionsMap: { [key: number]: IRailwayDirection[] };
}

export function mapStateToProps(state: IApplicationState): ISavedFiltersStoreProps {
  const { currentStations, directions, selectedStations: selectedStationsId } = state.stations;
  const stationDirectionsMap: { [stationId: number]: IRailwayDirection[] } = {};

  selectedStationsId.forEach(id => {
    const station = getStationById(currentStations, id);
    if (!station) {
      return;
    }
    station.directions.forEach(id => {
      const direction = directions.find(direction => direction.id === id);
      if (!direction) {
        return;
      }
      if (stationDirectionsMap[station.id]) {
        stationDirectionsMap[station.id].push(direction);
      } else {
        stationDirectionsMap[station.id] = [direction];
      }
    });
  });

  return {
    roadData: state.villageList.roadData ? pick(state.villageList.roadData, state.filters.road || []) : undefined,
    savedFilters: state.savedFilters,
    stationData: state.villageList.stationData
      ? pick(state.villageList.stationData, state.filters.station || [])
      : undefined,
    stationDirectionsMap,
  };
}

export interface ISavedFiltersDispatchProps {
  changeSavedFilter(value: ISavedFilter): void;
  onChangeFitInOneLine(value: boolean): void;
  onChangeRoadDistance(value: number): void;
  onChangeStationDistance(value: number): void;
  onRemoveAllSavedFilters(): void;
  removeSavedFilter(value: ISavedFilter): void;
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): ISavedFiltersDispatchProps {
  return {
    changeSavedFilter: value => dispatch(changeSavedFilter(value)),
    onChangeFitInOneLine: value => dispatch(fitInOneLine(value)),
    onChangeRoadDistance: value => dispatch(onChangeRoadDistance(value)),
    onChangeStationDistance: value => dispatch(onChangeStationDistance(value)),
    onRemoveAllSavedFilters: () => dispatch(onRemoveAllSavedFilters()),
    removeSavedFilter: value => dispatch(removeSavedFilter(value, true)),
  };
}

export const SavedFiltersContainer = connect<ISavedFiltersStoreProps, ISavedFiltersDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(SavedFilters);
